module.exports = __webpack_public_path__ + "BH.png?29d16f52bff3b3788dc142c1e8ef8a79";